module.exports = __webpack_public_path__ + "img/menu.add08ce4.svg";